import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type Admin = { id: number; name: string; email: string }

type AuthState = { token: string | null; admin: Admin | null }

const initialState: AuthState = {
  token: localStorage.getItem('adminToken'),
  admin: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<{ token: string; admin: Admin }>) => {
      state.token = action.payload.token
      state.admin = action.payload.admin
      localStorage.setItem('adminToken', action.payload.token)
    },
    clearAuth: state => {
      state.token = null
      state.admin = null
      localStorage.removeItem('adminToken')
    },
  },
})

export const { setAuth, clearAuth } = authSlice.actions
export default authSlice.reducer
